import { CardAccountDetailsOutlineIcon } from './CardAccountDetailsOutlineIcon';

/**
 * author: Michael Richins
 * id 6BD2BC65-C99A-42FB-A37E-85F5E8C91D32
 * name card-account-details-outline
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/card-account-details-outline.svg
 * tags
 * - Account / User 
 */
export const BusinessCardOutlineIcon = CardAccountDetailsOutlineIcon;
export default BusinessCardOutlineIcon